import PropTypes from 'prop-types';

export default {
    nodeId: PropTypes.string.isRequired,
    openInNewWindow: PropTypes.bool,
    providerName: PropTypes.string,
    redirectUrl: PropTypes.string,
}